import axios from 'axios';

const getFavoritePrograms = async (intl) => {
  try {
    const response = await axios.get(process.env.REACT_APP_GET_FAVORITE_PROGRAMS);
    return response.data;
  }
  catch (error) {
    console.error(intl.formatMessage({id: 'Callbacks.General.FetchError'}));
    return null;
  }
};

const postFavoriteProgram = async (intl, nodeId, isFavorite) => {
  if (!nodeId || typeof isFavorite !== 'boolean') {
    console.error(intl.formatMessage({id: 'Callbacks.General.FetchError'}));
    return null;
  }

  try {
    const response = await axios.post(process.env.REACT_APP_GET_FAVORITE_POST, {
      nodeId,
      isFavorite,
    });
    return response.data;
  }
  catch (error) {
    console.error(intl.formatMessage({id: 'Callbacks.General.FetchError'}));
    return null;
  }
};

export {getFavoritePrograms, postFavoriteProgram};
